module.exports = __webpack_public_path__ + "static/media/orange-photos-icon.de0f03fd.svg";